import React, { useEffect } from "react";
import { DataBox } from "./DataBox";
import { useSettingModel } from "../SettingModel";
import { YhPageHeader } from "@src/components/YhPageHeader";

export function BaseSetting() {
    const {
        loadData,
        resetState,
    } = useSettingModel()
    useEffect(() => {
        loadData({ pageNum: 1 }).then()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetState])
    return (
        <>
            <YhPageHeader title="系统配置" />
            <DataBox />
        </>
    );
}

